import A11yDialog from 'a11y-dialog';
document.querySelectorAll('.modalContainer').forEach(function (thisDialog) {
    var body = document.querySelector("body");
    // Open modal on page load
    document.addEventListener("DOMContentLoaded", (event) => {
    // @BE to update to trigger when conditions are correct
        new A11yDialog(document.getElementById('awaitingAuthentication')).show();
        body.classList.add('__blur');
    });
});
